export * from './CheckLineIcon'

export const CheckLineIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m.5 8.55 2.73 3.51a1 1 0 0 0 1.56.03L13.5 1.55"
    />
  </svg>
)
